<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>门店管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-row :gutter="24" class="header-font">
        <el-col :lg="8"><b>门店ID：</b>{{marketid}}</el-col>
        <el-col :lg="8"><b>卖场名称：</b>{{marketname}}</el-col>
        <el-col :lg="8"><b>省 市 区：</b>{{provincename}}-{{cityname}}-{{areaname}}</el-col>
      </el-row>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-tooltip class="item"
                    effect="dark"
                    content="刷新"
                    placement="top">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-refresh"
                     @click="onRefresh"></el-button>
        </el-tooltip>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column prop="orderid"
                         label="工单ID"></el-table-column>
        <el-table-column prop="status"
                         :formatter="formatStatus"
                         label="门店状态">
        </el-table-column>
      </el-table>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import marketMixins from '../../market/market.mixins'

export default {
  mixins: [table, marketMixins],
  computed: {
    ...Vuex.mapState('marketNg', {
      statusOpts: state => state.options.status,
    })
  },
  data () {
    return {
      table: [],
      marketname: null,
      provincename: null,
      cityname: null,
      areaname: null,
      marketid: this.$route.params.marketId,
      search: {
        marketid: this.$route.params.marketId,
      }
    }
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryMarketNgDetail', params)
    },
    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData ({data}) {
      this.$set(this, 'table', data.data)
      this.marketname = data.marketname
      this.provincename = data.provincename
      this.cityname = data.cityname
      this.areaname = data.areaname
      this.setPagination(data)
    },
    formatStatus (row, column, cellValue) {
      for (let i in this.statusOpts) {
        if (this.statusOpts[i].value === cellValue * 1) {
          return this.statusOpts[i].label
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/market-ng/pages/MarketNgDetail.vue